import { useEffect, useRef, useState } from 'react'
import { cn } from '@/lib/utils'
import { ADS_ENABLED } from '@/lib/google-ads'
import { ensureExoclickScript, getExoclickStatus, subscribeToExoclickStatus } from '@/lib/exoclick-ads'

declare global {
  interface Window {
    AdProvider?: Record<string, unknown>[]
  }
}

export interface ExoclickAdProps {
  className?: string
}

export function ExoclickAd({ className }: ExoclickAdProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const didPush = useRef(false)
  const [status, setStatus] = useState(getExoclickStatus())

  useEffect(() => {
    if (!ADS_ENABLED) return

    const unsubscribe = subscribeToExoclickStatus((newStatus) => {
      setStatus(newStatus)
    })

    ensureExoclickScript()

    // Push serve instruction once when component mounts
    if (!didPush.current) {
      didPush.current = true
      try {
        ;(window.AdProvider = window.AdProvider || []).push({ serve: {} })
      } catch (e) {
        console.error('Exoclick ad push error:', e)
        didPush.current = false
      }
    }

    return () => {
      unsubscribe()
    }
  }, [])

  if (!ADS_ENABLED || status.isBlocked) return null

  return (
    <div 
      ref={containerRef} 
      className={cn('exoclick-ad-scope', className)}
      style={{ display: 'none' }}
    >
      <ins 
        className="eas6a97888e6" 
        data-zoneid="5943574" 
      />
    </div>
  )
}
